import PageLayout from "@/pages/home/components/PageLayout";
import ContactSection from "@/pages/home/components/ContactSection";

export default function ContactPage() {
  return (
    <PageLayout>
      <ContactSection />
    </PageLayout>
  );
}
